import type { PaymentIncidentsTranslations } from "../interfaces/paymentIncidents";

export const paymentIncidentsTranslations: PaymentIncidentsTranslations = {
  provider_fallback: "el proveedor",
  organization_unknown: "Organización",
  action_cancel: "Cancelar",
  action_close: "Cerrar",
  action_back: "Atrás",
  action_retry: "Reintentar",
  status_pending_report: "Sin reportar",
  status_reported: "Reportada a {{provider}}",
  status_in_progress: "En gestión con {{provider}}",
  status_provider_refunded: "{{provider}} devolvió",
  status_resolved: "Cerrada",
  status_dismissed: "Descartada",
  type_credit_not_applied: "Abono no acreditado",
  type_credit_not_applied_hint:
    "{{provider}} lo da por completado, pero el comercio o la persona no recibió el dinero.",
  type_status_not_updated: "Estado sin actualizar",
  type_status_not_updated_hint:
    "Sigue en proceso en {{provider}} aunque ya debería haber terminado, como una orden OTC que no se cierra.",
  type_other: "Otra novedad",
  type_other_hint: "Cualquier otra cosa que haya que revisar con {{provider}}.",
  resolution_beneficiary_credited: "El beneficiario sí recibió el dinero",
  resolution_status_updated: "El proveedor actualizó el estado",
  resolution_other: "Otro motivo",
  case_strip_label: "Avance del reclamo",
  case_step_pending_report: "Sin reportar",
  case_step_reported: "Reportada",
  case_step_in_progress: "En gestión",
  case_step_closed: "Cerrada",
  case_dismissed: "Descartada: no era una novedad.",
  case_updated_today: "Tuvo movimiento hoy.",
  case_quiet_one: "Sin novedades desde hace 1 día.",
  case_quiet_other: "Sin novedades desde hace {{count}} días.",
  case_stale: "{{count}} días sin novedades: escríbele de nuevo a {{provider}}.",
  panel_title: "Novedad con el proveedor",
  panel_title_with_reference: "Novedad {{reference}}",
  panel_empty:
    "Si el cliente dice que este pago no llegó o se quedó trabado, abre una novedad para reportarlo a {{provider}} y seguirlo aquí.",
  panel_open: "Abrir novedad",
  panel_read_only: "Solo quienes pueden cargar billeteras pueden cambiar una novedad.",
  panel_opened_by: "abierta por {{email}}",
  panel_at_stake: "En juego",
  panel_case_reference: "Radicado de {{provider}}",
  panel_client_refund: "Reembolso al cliente",
  panel_copy_report: "Copiar reporte para {{provider}}",
  panel_copy_follow_up: "Copiar seguimiento para {{provider}}",
  panel_record: "Registrar",
  panel_refund: "Reembolsar al cliente",
  panel_reading_provider: "Consultando a {{provider}} para armar el reporte…",
  timeline_title: "Línea de tiempo",
  timeline_label: "Línea de tiempo de la novedad",
  record_provider_responded: "{{provider}} respondió",
  record_provider_refunded: "{{provider}} devolvió el dinero",
  record_resolved: "Cerrar la novedad",
  record_dismissed: "Descartar",
  record_note: "Agregar nota o imágenes",
  record_reopened: "Reabrir",
  refund_blocked_payout_not_paid:
    "No se puede reembolsar: el pago no figura como pagado. Si falló o se canceló, el dinero ya volvió solo; si sigue en proceso, todavía puede llegar.",
  refund_blocked_incident_closed: "Para reembolsar, reabre la novedad.",
  refund_blocked_wallet_not_found: "La organización ya no tiene la billetera de la que salió el pago.",
  refund_blocked_already_refunded: "Ya se le reembolsó al cliente.",
  event_opened: "Novedad abierta",
  event_report_copied: "Reporte copiado para {{provider}}",
  event_report_copied_follow_up: "Seguimiento copiado para {{provider}}",
  event_provider_responded: "{{provider}} respondió",
  event_provider_refunded: "{{provider}} devolvió el dinero",
  event_note: "Nota",
  event_resolved: "Novedad cerrada",
  event_dismissed: "Novedad descartada",
  event_reopened: "Novedad reabierta",
  event_client_refunded: "Reembolso al cliente",
  event_two_factor: "con 2FA",
  event_two_factor_hint: "Confirmado con el segundo factor de quien lo hizo.",
  event_recorded_on: "registrado el {{date}}",
  event_case_reference: "Radicado: {{reference}}",
  event_attachments: "Adjuntos",
  event_attachment_open: "Abrir {{name}}",
  event_attachment_unavailable: "No disponible",
  open_title: "Abrir novedad",
  open_description:
    "Queda registrada con tu correo. Después copias el reporte para {{provider}} y sigues el caso aquí.",
  open_field_type: "Tipo de novedad",
  open_field_description: "Qué pasó",
  open_field_description_hint:
    "Va tal cual en el reporte para {{provider}}: cuenta lo que vio el cliente o el comercio.",
  open_field_description_placeholder:
    "El datáfono mostró «Venta no realizada» y el comercio no recibió el dinero; el cliente pagó otra vez con tarjeta.",
  open_validation_description: "Cuenta qué pasó.",
  open_only: "Solo abrir",
  open_and_report: "Abrir y copiar reporte",
  open_error: "No pudimos abrir la novedad. Inténtalo de nuevo.",
  open_already_exists: "Este pago ya tenía una novedad: te la mostramos.",
  report_title: "Reporte para {{provider}}",
  report_description: "Pégalo en el canal de soporte de {{provider}}. La copia quedó en la línea de tiempo.",
  report_copy: "Copiar",
  report_copy_again: "Copiar otra vez",
  report_copied: "Copiado",
  report_copied_toast: "Reporte copiado",
  report_copy_error: "No se pudo copiar. Selecciona el texto y cópialo a mano.",
  report_auto_copied: "Ya está en tu portapapeles: pégalo en el canal de {{provider}}.",
  report_copy_hint: "Usa «Copiar» y pégalo en el canal de {{provider}}.",
  report_text_label: "Texto del reporte",
  report_evidence_stored:
    "No pudimos consultar a {{provider}} en este momento: los datos salen de lo que guardamos. Revisa que estén completos antes de enviarlo.",
  report_evidence_none:
    "No encontramos datos de {{provider}} para este pago: el reporte lleva solo los nuestros.",
  report_two_factor_required: "Para copiar el reporte necesitas activar la verificación en dos pasos.",
  report_two_factor_description:
    "Copiar el reporte para {{provider}} queda registrado con tu segundo factor.",
  event_dialog_title_provider_responded: "{{provider}} respondió",
  event_dialog_description_provider_responded: "Registra lo que contestó y, si lo dio, el radicado del caso.",
  event_dialog_confirm_provider_responded: "Guardar respuesta",
  event_note_placeholder_provider_responded:
    "Escalaron con Banrep y ACH; no hay tiempo de respuesta definido.",
  event_saved_provider_responded: "Respuesta registrada",
  event_dialog_title_provider_refunded: "{{provider}} devolvió el dinero",
  event_dialog_description_provider_refunded: "Marca la novedad como devuelta por {{provider}}. Se cierra.",
  event_dialog_confirm_provider_refunded: "Marcar devuelto",
  event_note_placeholder_provider_refunded: "La devolución llegó a la wallet el …",
  event_saved_provider_refunded: "Devolución registrada",
  event_dialog_title_resolved: "Cerrar la novedad",
  event_dialog_description_resolved:
    "Ciérrala cuando ya no quede nada pendiente con {{provider}}. Se puede reabrir.",
  event_dialog_confirm_resolved: "Cerrar novedad",
  event_note_placeholder_resolved: "La entidad confirmó que el abono sí quedó aplicado.",
  event_saved_resolved: "Novedad cerrada",
  event_dialog_title_dismissed: "Descartar la novedad",
  event_dialog_description_dismissed: "Para cuando no era una novedad. Se puede reabrir.",
  event_dialog_confirm_dismissed: "Descartar",
  event_note_placeholder_dismissed: "El cliente se equivocó de pago.",
  event_saved_dismissed: "Novedad descartada",
  event_dialog_title_note: "Agregar nota o imágenes",
  event_dialog_description_note: "Un seguimiento en la línea de tiempo: qué hiciste o qué te dijeron.",
  event_dialog_confirm_note: "Guardar",
  event_note_placeholder_note: "Les escribí de nuevo por el canal.",
  event_saved_note: "Nota guardada",
  event_dialog_title_reopened: "Reabrir la novedad",
  event_dialog_description_reopened: "Vuelve al último paso abierto que tuvo.",
  event_dialog_confirm_reopened: "Reabrir",
  event_note_placeholder_reopened: "El cliente lo volvió a reportar.",
  event_saved_reopened: "Novedad reabierta",
  event_field_resolution: "Por qué se cierra",
  event_field_case_reference: "Radicado",
  event_field_case_reference_hint: "El número de caso que dio {{provider}}, si lo dio.",
  event_field_day: "Cuándo pasó",
  event_field_day_hint: "Si fue otro día, ponlo: la línea de tiempo se ordena por esa fecha.",
  event_field_answer: "Qué respondió",
  event_field_note: "Nota",
  event_field_attachments: "Imágenes o documentos",
  event_validation_note: "Escribe una nota o adjunta un archivo.",
  event_error: "No pudimos guardarlo. Inténtalo de nuevo.",
  event_provider_refunded_info:
    "Esto no mueve dinero en Coloca: la devolución entra a la wallet de {{provider}} y se ve en «Saldos en proveedores». Si todavía no le reembolsaste al cliente, hazlo después con «Reembolsar al cliente».",
  event_provider_refunded_info_refunded:
    "Esto no mueve dinero en Coloca: la devolución entra a la wallet de {{provider}} y recupera lo que Coloca ya le reembolsó al cliente.",
  event_resolved_refunded_warning:
    "Al cliente ya se le reembolsó. Si el beneficiario sí recibió el pago, el cliente quedó con el dinero dos veces y hay que recuperarlo a mano.",
  attachments_add: "Adjuntar",
  attachments_hint: "Hasta {{max}} imágenes o PDF de {{size}} MB.",
  attachments_remove: "Quitar {{name}}",
  attachments_rejected_too_many: "Solo caben {{max}} archivos por entrada.",
  attachments_rejected_too_large: "{{name}} pesa más de {{size}} MB.",
  attachments_rejected_unsupported_type: "{{name}} no es una imagen ni un PDF.",
  refund_title: "Reembolsar al cliente",
  refund_title_review: "Revisa el reembolso",
  refund_title_done: "Reembolso acreditado",
  refund_description: "Le devuelves el pago a {{organization}} mientras {{provider}} lo resuelve.",
  refund_description_done: "El cliente ya tiene el dinero en su billetera y le llega el comprobante.",
  refund_field_amount: "Monto a reembolsar",
  refund_field_amount_hint:
    "Por defecto, todo lo que se le cobró: {{max}} {{currency}}. Puedes bajarlo, no subirlo.",
  refund_field_note: "Nota interna",
  refund_field_note_hint: "Opcional. Va a la nota interna y a la línea de tiempo; el cliente no la ve.",
  refund_review: "Revisar reembolso",
  refund_review_organization: "Organización",
  refund_review_wallet: "Billetera",
  refund_review_wallet_value: "Billetera {{currency}}",
  refund_review_charged: "Lo que se le cobró por ese pago",
  refund_review_amount: "Reembolso",
  refund_review_client_sees:
    "El cliente lo ve en su billetera como «Reembolso de Coloca Payments», con el pago reembolsado en el concepto, y le llega el comprobante por correo.",
  refund_review_coloca_money:
    "Es dinero de Coloca hasta que {{provider}} devuelva los fondos. No se puede deshacer desde aquí.",
  refund_review_checkbox: "Revisé el monto y la organización.",
  refund_confirm: "Reembolsar",
  refund_transit_aria: "Coloca acredita {{amount}} {{currency}} a {{name}}",
  refund_transit_from: "Coloca Payments",
  refund_error_already: "Esta novedad ya tiene un reembolso. Actualizamos la vista.",
  refund_validation_invalid: "Escribe un monto válido.",
  refund_validation_not_positive: "El monto debe ser mayor que cero.",
  refund_validation_precision: "{{currency}} admite hasta {{digits}} decimales.",
  refund_validation_exceeds: "No puede superar lo que se le cobró: {{max}} {{currency}}.",
  refund_two_factor_required: "Para reembolsar necesitas activar la verificación en dos pasos.",
  refund_two_factor_description: "El reembolso mueve dinero de Coloca: confírmalo con tu segundo factor.",
  summary_open: "Novedades abiertas",
  summary_open_meta: "{{pending}} sin reportar · {{waiting}} esperando respuesta",
  summary_stale: "Sin novedades hace 7 días o más",
  summary_stale_meta: "Para escribirle de nuevo al proveedor",
  summary_at_stake: "En juego",
  summary_advanced: "Adelantado por Coloca",
  summary_error: "No pudimos cargar el resumen de novedades.",
  summary_outdated:
    "No pudimos actualizar el resumen. Estas cifras son del {{time}} y pueden no estar al día.",
  summary_advanced_meta: "Reembolsado a clientes, sin devolución del proveedor todavía",
  filter_open: "Abiertas",
  filter_client_refunded: "Cliente reembolsado",
  filter_any: "Con novedad",
  filter_none: "Sin novedad",
  filter_pending_report: "Sin reportar",
  filter_reported: "Reportadas, sin respuesta",
  filter_in_progress: "En gestión",
  filter_provider_refunded: "Devueltas por el proveedor",
  filter_resolved: "Cerradas",
  filter_dismissed: "Descartadas",
  movements_days_quiet_one: "1 día sin novedades",
  movements_days_quiet_other: "{{count}} días sin novedades",
  movements_client_refunded: "Cliente reembolsado",
};
